import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des actions de tableau
 */
const tabActionsConfig = {
  entityName: 'tab-actions',
  apiEndpoint: '/api/config/tool/tab-actions',
  exportFileName: 'tab-actions',
  
  translations: {
    title: 'TAB_ACTIONS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { 
      key: 'function_tag', 
      label: 'Function Tag', 
      labelKey: 'TABLE_FUNCTION_TAG'
    },
    { 
      key: 'task_icon', 
      label: 'Icône', 
      labelKey: 'TABLE_TASK_ICON'
    },
    { 
      key: 'task_name', 
      label: 'Tâche', 
      labelKey: 'TABLE_TASK_NAME'
    },
    { 
      key: 'works_on', 
      label: 'Travaille sur', 
      labelKey: 'TABLE_WORKS_ON'
    },
    { 
      key: 'needs', 
      label: 'Nécessite', 
      labelKey: 'TABLE_NEEDS'
    },
    { 
      key: 'ia_language', 
      label: 'Langue IA', 
      labelKey: 'TABLE_IA_LANGUAGE'
    },
    { 
      key: 'use_ai', 
      label: 'Type IA', 
      labelKey: 'TABLE_USE_AI'
    },
    { 
      key: 'use_canon', 
      label: 'Use Canon', 
      labelKey: 'TABLE_USE_CANON',
      type: 'booleanTag'
    },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'function_tag',
      label: 'Function Tag',
      labelKey: 'TAB_ACTION_FUNCTION_TAG',
      type: 'dynamic-select',
      required: true,
      placeholder: 'isDefault, isCharacter, isBeat...',
      className: 'wa-form-group',
      dynamicSource: 'function_tag'
    },
    {
      name: 'task_icon',
      label: 'Icône de tâche',
      labelKey: 'TAB_ACTION_TASK_ICON',
      type: 'dynamic-select',
      placeholder: 'COMPUTE, WRITE, COPY...',
      className: 'wa-form-group',
      dynamicSource: 'task_icon'
    },
    {
      name: 'task_name',
      label: 'Nom de la tâche',
      labelKey: 'TAB_ACTION_TASK_NAME',
      type: 'dynamic-select',
      required: true,
      placeholder: 'DescribeImageAsPrompt, ArticleWriter...',
      className: 'wa-form-group',
      dynamicSource: 'task_name'
    },
    {
      name: 'works_on',
      label: 'Travaille sur',
      labelKey: 'TAB_ACTION_WORKS_ON',
      type: 'dynamic-select',
      placeholder: 'text, image, folder...',
      className: 'wa-form-group',
      dynamicSource: 'works_on'
    },
    {
      name: 'needs',
      label: 'Nécessite',
      labelKey: 'TAB_ACTION_NEEDS',
      type: 'dynamic-select',
      placeholder: 'Nothing, Parent, Article...',
      className: 'wa-form-group',
      dynamicSource: 'needs'
    },
    {
      name: 'ia_language',
      label: 'Langue IA',
      labelKey: 'TAB_ACTION_IA_LANGUAGE',
      type: 'dynamic-select',
      placeholder: 'FR, EN...',
      className: 'wa-form-group',
      dynamicSource: 'ia_language'
    },
    {
      name: 'link',
      label: 'Lien',
      labelKey: 'TAB_ACTION_LINK',
      type: 'text',
      placeholder: 'relatedCharacters, relatedArticles...',
      className: 'wa-form-group'
    },
    {
      name: 'entity_class',
      label: 'Classe d\'entité',
      labelKey: 'TAB_ACTION_ENTITY_CLASS',
      type: 'text',
      placeholder: 'Person, Organization...',
      className: 'wa-form-group'
    },
    {
      name: 'link_entity_class',
      label: 'Classe d\'entité liée',
      labelKey: 'TAB_ACTION_LINK_ENTITY_CLASS',
      type: 'dynamic-select',
      placeholder: 'none, relatedCharactersPerson...',
      className: 'wa-form-group',
      dynamicSource: 'link_entity_class'
    },
    {
      name: 'use_ai',
      label: 'Type d\'IA',
      labelKey: 'TAB_ACTION_USE_AI',
      type: 'dynamic-select',
      placeholder: 'text, vision, translation, none...',
      className: 'wa-form-group',
      dynamicSource: 'use_ai'
    },
    {
      name: 'use_canon',
      label: 'Use Canon',
      labelKey: 'TAB_ACTION_USE_CANON',
      type: 'booleanTag'
    },
    {
      name: 'data_format',
      label: 'Format de données',
      labelKey: 'TAB_ACTION_DATA_FORMAT',
      type: 'dynamic-select',
      placeholder: 'text, html, bbcode...',
      className: 'wa-form-group',
      dynamicSource: 'data_format'
    },
    {
      name: 'from_text_system',
      label: 'Prompt système',
      labelKey: 'TAB_ACTION_FROM_TEXT_SYSTEM',
      type: 'textarea',
      placeholder: 'Instructions système pour l\'IA...',
      rows: 3,
      className: 'wa-form-group'
    },
    {
      name: 'from_text_assistant',
      label: 'Prompt assistant',
      labelKey: 'TAB_ACTION_FROM_TEXT_ASSISTANT',
      type: 'textarea',
      placeholder: 'Instructions pour l\'assistant...',
      rows: 2,
      className: 'wa-form-group'
    },
    {
      name: 'from_text_user',
      label: 'Prompt utilisateur',
      labelKey: 'TAB_ACTION_FROM_TEXT_USER',
      type: 'textarea',
      placeholder: 'Template pour l\'utilisateur...',
      rows: 4,
      className: 'wa-form-group'
    },
    {
      name: 'from_text_temperature',
      label: 'Température',
      labelKey: 'TAB_ACTION_FROM_TEXT_TEMPERATURE',
      type: 'number',
      step: 0.1,
      min: 0,
      max: 2,
      placeholder: '0.7',
      className: 'wa-form-group'
    },
    {
      name: 'post_ia_treatment',
      label: 'Traitement post-IA',
      labelKey: 'TAB_ACTION_POST_IA_TREATMENT',
      type: 'dynamic-select',
      placeholder: 'none, isCharacter>Article...',
      className: 'wa-form-group',
      dynamicSource: 'post_ia_treatment'
    },
    {
      name: 'output_content_text',
      label: 'Contenu de sortie',
      labelKey: 'TAB_ACTION_OUTPUT_CONTENT_TEXT',
      type: 'textarea',
      placeholder: 'Template de sortie...',
      rows: 3,
      className: 'wa-form-group'
    },
    {
      name: 'article_field_identification',
      label: 'Identification champ article',
      labelKey: 'TAB_ACTION_ARTICLE_FIELD_IDENTIFICATION',
      type: 'dynamic-select',
      placeholder: 'none, isCharacter>Article...',
      className: 'wa-form-group',
      dynamicSource: 'article_field_identification'
    },
    {
      name: 'from_text_copy',
      label: 'Template titre utilisateur',
      labelKey: 'TAB_ACTION_FROM_TEXT_COPY',
      type: 'text',
      placeholder: 'Template pour le titre...',
      className: 'wa-form-group'
    },
    {
      name: 'from_url',
      label: 'URL source',
      labelKey: 'TAB_ACTION_FROM_URL',
      type: 'text',
      placeholder: '{{part.image.url}}...',
      className: 'wa-form-group'
    },
    {
      name: 'tag_set_action',
      label: 'Action de tag',
      labelKey: 'TAB_ACTION_TAG_SET_ACTION',
      type: 'dynamic-select',
      placeholder: 'NULL, Copied...',
      className: 'wa-form-group',
      dynamicSource: 'tag_set_action'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'TAB_ACTION_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'function_tag',
      label: 'Function Tag',
      labelKey: 'FILTER_FUNCTION_TAG',
      type: 'dynamic-select',
      dynamicSource: 'function_tag'
    },
    {
      name: 'task_name',
      label: 'Tâche',
      labelKey: 'FILTER_TASK_NAME',
      type: 'dynamic-select',
      dynamicSource: 'task_name'
    },
    {
      name: 'works_on',
      label: 'Travaille sur',
      labelKey: 'FILTER_WORKS_ON',
      type: 'dynamic-select',
      dynamicSource: 'works_on'
    },
    {
      name: 'ia_language',
      label: 'Langue IA',
      labelKey: 'FILTER_IA_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ia_language'
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    function_tag: '',
    task_icon: '',
    task_name: '',
    works_on: '',
    needs: '',
    ia_language: 'FR',
    link: '',
    entity_class: '',
    link_entity_class: null,
    use_ai: null,
    use_canon: false,
     data_format: 'text',
    from_text_system: '',
    from_text_assistant: '',
    from_text_user: '',
    from_text_temperature: null,
    post_ia_treatment: null,
    output_content_text: '',
    article_field_identification: null,
    from_text_copy: '',
    from_url: '',
    tag_set_action: null,
    is_active: true
  }
};

/**
 * Composant d'administration des actions de tableau
 */
export default function AdminTabActionsTab() {
  return (
    <AdminDataTable {...tabActionsConfig} />
  );
}
